import React from "react";
import { useSelector, useDispatch } from "react-redux";

import SortFieldsDropdown from "src/app/dropdowns/SortFieldsDropdown/SortFieldsDropdown";
import { FieldSelect } from "src/app/components/FieldSelect/FieldSelect";
import { setActiveSortingColumn } from "src/redux";

export default function TaskSortFieldsDropdown({ fields }) {
  const {
    taskFiltersReducer: { activeSortingColumn },
    projectReducer: { taskType },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const selectionField = {
    id: taskType,
    name: taskType,
    title: taskType,
    isVisible: true,
    key: taskType,
  };

  const allFields = [selectionField, ...fields];

  const foundActiveSortingColumn = allFields.find(
    (field) => field.id === activeSortingColumn,
  );

  const selectField = (fieldId) => {
    if (activeSortingColumn !== fieldId) {
      dispatch(setActiveSortingColumn(fieldId));
    } else {
      dispatch(setActiveSortingColumn(""));
    }
  };

  const dropdownMenuItems = (clickFunction) => {
    return fields
      .filter((field) => field.isVisible)
      .map((field, index) => (
        <FieldSelect
          key={field.id}
          fieldId={field.id}
          fieldTitle={field.title}
          handleClick={() => {
            selectField(field.id);
            clickFunction?.();
          }}
          activeSortingColumn={activeSortingColumn}
          capitalize={index === 0}
        />
      ));
  };

  return (
    <SortFieldsDropdown
      sortBy={foundActiveSortingColumn?.title}
      dropdownMenuItems={dropdownMenuItems}
      stickToBottom
    />
  );
}
